import React, { useState, useEffect } from 'react'

import { Grid, Skeleton } from 'antd-mobile'
import intl from 'react-intl-universal'
import { CheckCircleFill, ClockCircleOutline } from 'antd-mobile-icons'
import { getOrderDetailModel } from '../../../model/store'
import { getLanguageStore } from '../../../utils/storage/language'
import { formatJSON } from '../../../utils'
import OrderDetail from '../../../views/orders/Detail'
export default function BookingResult({ orderId }) {
    const [orderDetail, setOrderDetail] = useState(null)
    const [extendData, setExtendData] = useState(null)

    const getOrderDetail = async (orderId) => {
        const res = await getOrderDetailModel({ orderId, lang: getLanguageStore() })
        const { extendColumn } = res
        setExtendData(formatJSON(extendColumn))
        setOrderDetail(res)
    }

    useEffect(() => {
        if (orderId) {
            //getOrderDetail(orderId)
        }
    }, [orderId])

    return (
        <div className='result-wrapper' style={{ margin: 15 }}>
            <div className='result-content'>
                <OrderDetail orderId={orderId} needHeader={false} />
            </div>
        </div>
    )
}
